import { type AreaCode } from "$lib/utils/areaUtils";

export const getPriceWithAreaMva = (price: number, areaCode: AreaCode) => {
  return areaCode !== "NO4" ? price * 1.25 : price;
};

/**
 * Function returns price with stømstøtte and MVA where applicable
 * @param priceRaw: number - price excluded MVA
 * @param areaCode: AreaCode - area code
 * @param date: Date - date to use for different support details TODO
 * @returns number - price with MVA and stømstøtte
 */
export const getPriceWithStromstotte = (priceRaw: number, areaCode: AreaCode, date?: Date) => {

  // TODO: when new stømstøtte-ordning, check date for what function to use
  const stotteDate = date ? date : new Date();
  const stotteYear = stotteDate.getFullYear();
  const stotteMonth = stotteDate.getMonth();

  if (stotteYear >= 2026) return getPriceWithStromstotte2026(priceRaw, areaCode);
  if (stotteYear >= 2025) return getPriceWithStromstotte2025(priceRaw, areaCode);
  if (stotteYear >= 2024) return getPriceWithStromstotte2024(priceRaw, areaCode);
  if (stotteYear >= 2023 && stotteMonth >= 8) return getPriceWithStromstotte2023SepToDec(priceRaw, areaCode);
  // Else return price with areas applied MVA
  else return getPriceWithAreaMva(priceRaw, areaCode);
};

export const applicableForStromstotte = (priceRaw: number, date?: Date) => {
  const stotteDate = date ? date : new Date();
  const stotteYear = stotteDate.getFullYear();
  const stotteMonth = stotteDate.getMonth();

  if (stotteYear >= 2026) return priceRaw >= 77;
  if (stotteYear >= 2025) return priceRaw >= 75;
  if (stotteYear >= 2024) return priceRaw >= 73;
  if (stotteYear >= 2023 && stotteMonth >= 8) return priceRaw >= 70;
  else return priceRaw >= 73;
};

// Søtte til husholdningene 2023 fra og med september
/**
 * Function returns price with stømstøtte and MVA where applicable
 * @param priceRaw: number - price excluded MVA
 * @param areaCode: AreaCode - area code
 * @returns number - price with MVA and stømstøtte
 */
const getPriceWithStromstotte2023SepToDec = (priceRaw: number, areaCode: AreaCode) => {
  // Terskelverdien er 70 øre per kilowattime (kWh) eksklusive merverdiavgift.
  const amountForSupport = priceRaw < 70 ? 0 : priceRaw - 70;
  const support = amountForSupport * .9;

  // Return usual area price
  return getPriceWithAreaMva(priceRaw - support, areaCode);
};

// Søtte til husholdningene 2024
/**
 * Function returns price with stømstøtte and MVA where applicable
 * @param priceRaw: number - price excluded MVA
 * @param areaCode: AreaCode - area code
 * @returns number - price with MVA and stømstøtte
 */
const getPriceWithStromstotte2024 = (priceRaw: number, areaCode: AreaCode) => {
  // Terskelverdien er 73 øre per kilowattime (kWh) eksklusive merverdiavgift.
  const amountForSupport = priceRaw < 73 ? 0 : priceRaw - 73;
  const support = amountForSupport * .9;

  // Return usual area price
  return getPriceWithAreaMva(priceRaw - support, areaCode);
};

// Søtte til husholdningene 2025
/**
 * Function returns price with stømstøtte and MVA where applicable
 * @param priceRaw: number - price excluded MVA
 * @param areaCode: AreaCode - area code
 * @returns number - price with MVA and stømstøtte
 */
const getPriceWithStromstotte2025 = (priceRaw: number, areaCode: AreaCode) => {
  // Terskelverdien er foreslått til 75 øre per kilowattime (kWh) eksklusive merverdiavgift
  const amountForSupport = priceRaw < 75 ? 0 : priceRaw - 75;
  const support = amountForSupport * .9;

  // Return usual area price
  return getPriceWithAreaMva(priceRaw - support, areaCode);
};


// Søtte til husholdningene 2026
/**
 * Function returns price with stømstøtte and MVA where applicable
 * @param priceRaw: number - price excluded MVA
 * @param areaCode: AreaCode - area code
 * @returns number - price with MVA and stømstøtte
 */
const getPriceWithStromstotte2026 = (priceRaw: number, areaCode: AreaCode) => {
  // Terskelverdien er foreslått til 77 øre per kilowattime (kWh) eksklusive merverdiavgift
  const amountForSupport = priceRaw < 77 ? 0 : priceRaw - 77;
  const support = amountForSupport * .9;

  // Return usual area price
  return getPriceWithAreaMva(priceRaw - support, areaCode);
};

